<template>
  <div class="container mt-5">
 <h1>Datenschutzerklärung</h1>
 <br>
    <p>Hier möchten wir über die Art und Weise wie Daten auf unserer Webseite (forya.de) verarbeitet werden informieren.</p><br>
    
    <strong>Verantwortlicher für die Datenverarbeitung</strong> <br><br>
    
    <p>Verantwortlicher gemäß Art. 4 Abs. 7 DSGVO ist:<br><br>
    Trederklein GbR<br>
      Seestr. 2<br>
      30916 Isernhagen<br>
      E-Mail: trederklein@gmail.com<br>
    </p><br>

    <strong>Informationen über die Verwendung Ihrer Daten auf forya.de</strong> <br><br>

    <p>Personenbezogene Daten:<br>
    Auf forya.de werden keine personenbezogene Daten wie Email-Adresse, Name, Vorname, Adresse und weiteres gesammelt.</p><br>

    <strong>Verwendung von Cookies auf forya.de </strong><br><br>
 
    <p>Auf forya.de werden keine Cookies gesetzt.</p><br>

    <strong>Änderung der Datenschutzerklärung</strong><br><br>
    <p>Wir behalten uns das Recht vor, diese Datenschutzerklärung jederzeit unter Beachtung der geltenden Datenschutzvorschriften zu ändern. Derzeitiger Stand ist November 2023.</p>
  </div>
</template>

<script>
export default {
  name: 'DatenschutzPage'
}
</script>